import { CaptionModel } from "../../models";

import { mockUiBlockModel, mockAdfDocument } from ".";

export function mockCaptionModel({
    id = "caption-1234",
    type = "caption",
    locale = "en",
    content = mockCaptionModelContent()
}: Partial<CaptionModel> = {}): CaptionModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type CaptionModelContent = CaptionModel["content"];

export function mockCaptionModelContent({
    title = "Example caption",
    content = mockUiBlockModel(),
    caption = mockAdfDocument(),
    ...optionals
}: Partial<CaptionModelContent> = {}): CaptionModelContent {
    return {
        title,
        content,
        caption,
        ...optionals
    };
}
